import axios from 'axios';

export default class DealSystemService {
  static async getByDealSystemId(dealSystemId, { signal } = {}) {
    return (await axios.get(`deal-system/${dealSystemId}`, { signal })).data;
  }

  static async getByCustomer(params, { signal } = {}) {
    return (await axios.get('deal-system/get-by-customer', { params, signal }))
      .data;
  }

  static async getAllByDealId(dealId, { signal } = {}) {
    return (await axios.get(`deal/${dealId}/info/systems`, { signal })).data;
  }

  static async getAllowedSystemsForUser({ signal } = {}) {
    return (await axios.get('deal/type-systems', { signal })).data;
  }
}
